import $ from "jquery";
import * as actionTypes from "../constants/ActionConstants";
import config from "../Config";

export function submit(data) {
  return {
    type: actionTypes.SUBMIT,
    data,
  };
}

export function create(data) {
  return {
    type: actionTypes.CREATE,
    data,
  };
}

export function createEmployeeSuccess(data) {
  return {
    type: actionTypes.CREATE_EMPLOYEE_SUCCESS,
    data,
  };
}

export function createEmployeeFailure(error) {
  return {
    type: actionTypes.CREATE_EMPLOYEE_FAILURE,
    error,
  };
}

export function submitResponseSuccess(data) {
  return {
    type: actionTypes.SUBMIT_RESPONSE_SUCCESS,
    data,
  };
}

export function submitResponseFailure(error) {
  return {
    type: actionTypes.SUBMIT_RESPONSE_FAILURE,
    error,
  };
}

export function createEmployee(
  employerURLKey,
  locationURLKey,
  vendorEmployeeId,
  accessKeyId
) {
  return dispatch => {
    const data = $.ajax({
      url: `${config.apiURL}/employees`,
      headers: {
        Accept: "application/json; version=1",
      },
      data: {
        employee: {
          employer: {
            url_key: employerURLKey,
          },
          location: {
            url_key: locationURLKey,
          },
        },
        vendor_employee_id: vendorEmployeeId,
        access_key_id: accessKeyId,
      },
      method: "POST",
      success(response) {
        dispatch(createEmployeeSuccess(response));
      },
      error(error) {
        dispatch(createEmployeeFailure(error));
      },
    });
    return data;
  };
}

export function submitResponse(employee_id, employee_data) {
  return dispatch => {
    const data = $.ajax({
      method: "PUT",
      url: `${config.apiURL}/employees/${employee_id}`,
      headers: {
        Accept: "application/json; version=1",
      },
      data: { employee: employee_data },
      success(response) {
        dispatch(submitResponseSuccess(response));
      },
      error(error) {
        dispatch(submitResponseFailure(error));
      },
    });
    return data;
  };
}



// WEBPACK FOOTER //
// ./src/actions/surveyActionCreators.js